import router from "@/router";
import {CyrillicToLatin} from "@/utils/stringHelper";
import useRouterStore, {RouteGroups} from "@/stores/useRouterStore";
import {useAuthStore} from "@/stores/auth";
import {GetAttestationRoutes} from "@/services/attestations/index";

export async function InitAttestationRoutes() {
    const authStore = useAuthStore();
    const hasUser = !!authStore.userData;
    if (!hasUser) return;

    const routes = await GetAttestationRoutes();
    const routeStore = useRouterStore();

    router.addRoute({
        path: "/attestations",
        name: "attestations",
        component: () => import("@/layouts/Default.vue"),
        children: routes.data.data.map((route) => ({
            path: CyrillicToLatin(reformatName(route.title)),
            name: `attestations.${route.id}`,
            meta: {
                type: {...route, title: route.title.replace(":", "и")},
                middleware: "auth",
                accesses_redirect: true
            },
            component: () => import("@/views/attestations/Index.vue"),
        })),
    });

    const group = routeStore.addGroup(RouteGroups.RESERVE, 1);
    group.children.push({
        name: "attestations",
        slug: "attestations",

        children: routes.data.data.map((route) => {
            const name = reformatName(route.title, " и ").toUpperCase();
            return {
                name: route.short_title
                    ? route.short_title.replace(":", "и")
                    : route.translated_title.replace(":", "и"),
                title: route.title.replace(":", "и"),
                slug: CyrillicToLatin(reformatName(route.title)),
                to: {name: `attestations.${route.id}`},
            };
        }),
    });
}

const reformatName = (str, joinAnd = "-") => {
    return str
        .split(" ")
        .map((str) => str.charAt(0))
        .join("")
        .toLowerCase()
        .split(":")
        .join(joinAnd);
};
